export default {
	columns: [
		{ key: 'restaurantName', label: 'business', isSortable: true },
		{ key: 'menu', label: 'Menu' },
		{ key: 'status', label: 'Status', isSortable: true },
	],
	menuItemStatuses: [
		{ value: 0, label: 'Inactive', mapIcon: 'inRestaurant', color: '#eead4a' },
		{ value: 1, label: 'Active', mapIcon: 'inRestaurant', color: '#5fbcde' },
		{ value: 2, label: 'Deleted', mapIcon: 'inRestaurant', color: '#0fc4b3' },
		{ value: 3, label: 'Pending', mapIcon: 'inRestaurant', color: '#b882c4' },
		{ value: 4, label: 'Accepted', mapIcon: 'inRestaurant', color: '#35cd96' },
		{ value: 5, label: 'Rejected', mapIcon: 'inRestaurant', color: '#b57e5b' },
		{ value: 6, label: 'Canceled', mapIcon: 'inRestaurant', color: '#ba0404' },
	],
};
